<div mat-dialog-content>
  <div class="row">
    <div class="col-md-12 text-center">
      <gs-icon type="WARN"></gs-icon>
      <div class="confirm">Are you sure?</div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 body">
      <div>『{{ scope.item.tenantName }}』を削除しますか？</div>
      <small class="caption">※注意 : この操作は元に戻せません</small>
    </div>
  </div>
</div>
<div class="row mt-10 mb-10">
  <div class="col-md-12 text-center">
    <div class="small">Type the tenant name to proceed.</div>
    <div class="input-confirm">
      <input type="text" placeholder="{{ scope.item.tenantName }}" [(ngModel)]="scope.nameConfirm" />
    </div>
    <div *ngIf="scope.error">
      <small class="error">The input was not valid.</small>
    </div>
  </div>
</div>

<div mat-dialog-actions class="mt-10">
  <div class="button-set text-center">
    <button
      mat-stroked-button
      type="button"
      [mat-dialog-close]="false"
      tabindex="-1">
      cancel
    </button>
    <button mat-stroked-button type="button" (click)="onSubmit()" tabindex="-1">
      ok
    </button>
  </div>
</div>
